import { apiInstance, gql } from "@/services/httpAdapter";

export async function getFniProductsByPayPeriod(variables: {
	locationId: string | undefined;
	commissionCycleId: string | undefined;
	payPeriodId: string | undefined;
}) {
	if (!variables.locationId || !variables.payPeriodId) {
		return [];
	}
	const query = gql`
		query getFniProductsByPayPeriod($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!) {
			getFniProductsByPayPeriod(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
				_id
				employeeName
				dlcd
				product
				trntype
				amtDueWtyCo
				lastName
				firstName
				cancelAmount
				stockNumber
				dealNumber
				chargeBackGross
				cancellationDate
				saleDate
			}
		}
	`;

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getFniProductsByPayPeriod || [];
	} catch (err) {
		throw new Error(err as string);
	}
}
